<template>
  <Page :title="title">
    <div class="pageView-index">
      <!-- logo -->
      <div class="logo" v-show="shows">
        <img :src="require('@/assets/img/logo.png')" alt="">
      </div>
      <div v-for="(items,index)  in list" v-bind:key="index" class="menu_list_flex">
        <div class="menu_headerTitl">{{items .name}}</div>
        <div class="flex">
          <div v-for="(item,index) in items.subMenuList" class="menu_list" v-bind:key="index"  @click="navigation_(item.id,item)" >
            <img :src='item.icon?http+item.icon:require("@/assets/img/1.png")' alt="">
            <div class="menu_list_font">{{item.name}}</div>
            <div class="statues"  v-if="item.num!=0" >{{item.num}}</div>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>



<script>
export default {
  name: "Index-Page",
  data() {
    return {
      title: "首页",
      "list": [

        ],
      codes: "",
      sign: "",
      http:this.$http,
      shows:false
    };
  },
  methods: {
    navigation_(_ID,val){
     this.setState(_ID)
     this.$parent.IdCode=_ID;
     if(/(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g.test(val['link'])){
        //拿到token
        if (_ID==58){
          this.chatSale(val)
        }else {
          window.location.href=val['link']
        }

      }else{
      /**
       * @param {Number}  _ID      id来判断路由   默认传  路由传递 IdCode 功能按钮权限判断
       **/
      switch(_ID){
        case 11  :
          var params = {
            q : this.$Base64.encode(JSON.stringify(({
              notDispatch : "1",
            }))),
            name: _ID,
            IdCode:_ID,
            show:2
          };
          this.$router.push({path: "/Client", query: params});
         break
         case 12  :this.$router.push({ path: "/Client", query: {IdCode:_ID} });break
         case 14  :this.$router.push({ path: "/StoresNumbers", query: {IdCode:_ID} });break
         case 53  :this.$router.push({ path: "/active/apply", query: {menuId:_ID,campFlowType:2} });break
         case 23  :this.$router.push({ path: "/active/apply", query: {IdCode:_ID} });break
         case 24  :this.$router.push({ path: "/active/list", query: {menuId:_ID,id:'activeList'} });break
         case 26  :this.$router.push({ path: "/active/reportList", query: {IdCode:_ID,id:'reportList'} });break
         case 25  :this.$router.push({ path: "/active/reportApply", query: {IdCode:_ID} });break
        // 徕卡学院
         case 19  :this.$router.push({ path: "/addCurriculum", query: {name:_ID} });break
         case 20  :this.$router.push({ path: "/listCurriculum", query: {name:_ID} });break
         case 21  :
          var params = {
            q : this.$Base64.encode(JSON.stringify(({
              allCourse : "1"
            }))),
            name: _ID,
            IdCode:_ID,
            show:1
          };
          this.$router.push({path: "/Client", query: params});
          break
       // 销售报表
         case 15 :this.$router.push({ path: "/clientCare", query: {name:_ID} });break
         case 16 :
           this.$wxuserUtil.clearDeptCache();
           this.$router.push({ path: "/resportList", query: {name:_ID} });
           break;
         case 17 :this.$router.push({ path: "/report4SalesAnalysis", query: {name:_ID} });break
      }}

    },

    /**
     *  数字运营平台 处理方式
     */
    chatSale(val){
      var userId = this.$wxuserUtil.getUserId();
      var that=this;
      var  loginTokenData=this.$api.getSync("api/lk/userGetLoginToken?salesId="+userId,{})
      if (loginTokenData.Code==200){
        let link=val['link']+"?token="+loginTokenData.Data.Token+"&strAccount="+userId
        window.location.href=link;
      }else {
        that.$notify({
          message:loginTokenData.Msg,
          duration: 1000,
          background: "#ED1B1B"
        });
      }

    },

    /**
     *   获取菜单
     *   @param {salesId}
     */
    subMenuList_(){
      var userId = this.$wxuserUtil.getUserId();
      if(!userId){
        return ;
      }

      var key_menu = this.$wxuserUtil.KEY_MENU;
      this.list = this.addMenuList(1,this.$wxuserUtil.getMenu());
      this.shows=true;

      if(!this.list){
        this.$api.getMenuList({salesId:userId}).then(response=>{
          if(response.success==true){
            this.$wxuserUtil.storage.set(key_menu,response.data);
            this.list=response.data;
          }else{
            this.$notify({
              message:`获取用户失败,${response.msg}`,
              duration: 1000,
              background: "#ED1B1B"
            });
          }
        })
      }
      this.queryWorkBenchCnt();
    },
   /**
    *
    * 状态缓存
    *
    **/
    setState(ID){
       switch(ID){
             case 12   :   this.$store.commit('setShow',"");break
             case 11   :   this.$store.commit('setShow',2);break
             case 21   :   this.$store.commit('setShow',1);break
       }
       switch(ID){
             case 12   :    localStorage.setItem("show","");break
             case 11   :    localStorage.setItem("show",2);break
             case 21   :    localStorage.setItem("show",1);break
       }
    },
   /**
    *
    * 工作台数量
    *
    **/
   queryWorkBenchCnt(){
       this.$api.queryWorkBenchCnt({
         salesId:this.$wxuserUtil.getUserId()
       }).then(response=>{
               if(response.success){
                  let  data  =  [{
                       id:11,
                       num:response.data.unDispatchCnstCnt||0,
                      },{
                       id:15,
                       num:response.data.careCustCnt||0,
                      },{
                       id:24,
                       num:response.data.waitAuditCampCnt||0,
                      },{
                       id:26,
                       num:response.data.waitAuditCampReportCnt||0,
                      }]
                    this.list=this.addMenuList(2,this.list,data);
               }
       })
   },
   /**
    *
    *  追加工作台数量
    *
    */
    addMenuList(ID,data,CD_){
        if(Array.isArray(data)){
          for(let  i=0; i<data.length;i++){
              if(data[i]['subMenuList']||data[i]['subMenuList'].length>0){
                 let $D_    =   data[i]['subMenuList'];
                 for(let o=0;   o <$D_.length;  o++){
                      if(ID==1){
                        $D_[o]['num'] =  0;
                      }else{
                         for(let c=0;c<CD_.length;c++){
                              if($D_[o]['id']==CD_[c]['id']){
                                  $D_[o]['num']=CD_[c]['num']<100?CD_[c]['num']:"···"
                              }
                         }
                      }
                 }
              }
          }
          return data;
        }else{
          return [];
        }

    },
  },
  beforeMount(){

  },
  mounted() {
    this.subMenuList_();


  },
  created() {

     var path=window.sessionStorage.getItem("redirect_path")
     var redirect_query=window.sessionStorage.getItem("redirect_query")
     if(path!="/"){
       if(redirect_query!=""&&redirect_query!=null){
         path=path+"?"+redirect_query
       }
       window.sessionStorage.removeItem("redirect_path")
       window.sessionStorage.removeItem("redirect_query")
       this.$router.push({ path:  path })
     }


  },
  watch: {}
};
</script>



<style lang="less" src="~p/pageView-index.less"></style>



// WEBPACK FOOTER //
// src/components/index/index.vue